import { IPerfectScrollState } from "../scroll/perfectScrollModel";

export const verticalBarStateSelector = (s: IPerfectScrollState) => ({
    scrollbarYActive: s.status?.scrollbarYActive ?? false,
    maxScrollbarLength: s.options?.maxScrollbarLength,
    minScrollbarLength: s.options?.minScrollbarLength,
    containerHeight: s.verticalDimension?.containerMeasure,
    contentHeight: s.verticalDimension?.contentMeasure,
    roundedScrollTop: Math.floor(s.verticalDimension?.scrollMeasure),
});
